(function(){
  var K='wx_wishlist',R='wx_recent',HEART="<svg viewBox='0 0 24 24'><path d='M12 21s-8-5.2-8-11a4.6 4.6 0 018-3 4.6 4.6 0 018 3c0 5.8-8 11-8 11z'/></svg>";
  function rd(k){try{return JSON.parse(localStorage.getItem(k))||[]}catch(e){return []}}
  function wr(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
  function get(){return rd(K)}
  function save(a){wr(K,a);paint()}
  function has(h){return get().indexOf(h)>-1}
  function toggle(h){var a=get(),i=a.indexOf(h);if(i>-1)a.splice(i,1);else a.push(h);save(a)}
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function paint(){
    var n=get().length;
    document.querySelectorAll('[data-wx-wcount]').forEach(function(e){e.textContent=n;e.style.display=n?'flex':'none'});
    document.querySelectorAll('[data-wx-wish]').forEach(function(b){var on=has(b.dataset.wxWish);b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');var l=b.querySelector('[data-l]');if(l)l.textContent=on?'Added to Wishlist':'Add to Wishlist'});
  }
  function mk(h,cls,label){
    var b=document.createElement('button');b.type='button';b.className='wx-heart '+cls;b.dataset.wxWish=h;b.setAttribute('aria-label','Wishlist');
    b.innerHTML=HEART+(label?"<span data-l>Add to Wishlist</span>":'');
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();toggle(h)});
    return b;
  }
  function handleFrom(href){var p=href.split('/products/')[1];return p?p.split('?')[0].split('#')[0].split('/')[0]:null}
  function inject(){
    document.querySelectorAll('.card-wrapper').forEach(function(w){
      if(w.querySelector('.wx-heart'))return;
      var a=w.querySelector("a[href*='/products/']");if(!a)return;
      var h=handleFrom(a.getAttribute('href'));if(!h)return;
      var host=w.querySelector('.card__inner')||w;if(getComputedStyle(host).position==='static')host.style.position='relative';
      host.appendChild(mk(h,'wx-heart--card',false));
    });
    if(location.pathname.indexOf('/products/')>-1&&!document.querySelector('.wx-heart--pdp')){
      var pf=document.querySelector('product-form');
      if(pf){var h2=handleFrom(location.pathname);if(h2){var anchor=document.querySelector('.wx-trust')||pf;anchor.parentNode.insertBefore(mk(h2,'wx-heart--pdp',true),anchor.nextSibling)}}
    }
    paint();
  }
  function cards(list,target,withRm){
    Promise.all(list.map(function(h){return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})})).then(function(ps){
      target.innerHTML=ps.filter(Boolean).map(function(p){
        var img=p.featured_image?p.featured_image.replace(/\.(jpg|jpeg|png|webp|gif)(\?|$)/i,'_600x.$1$2'):'';
        return "<div class='wx-wcard'><a href='"+esc(p.url)+"'><img src='"+esc(img)+"' alt='' loading='lazy'></a>"+(withRm?"<button type='button' class='wx-wrm' data-rm='"+esc(p.handle)+"' aria-label='Remove'>&times;</button>":'')+"<a class='wx-wt' href='"+esc(p.url)+"'>"+esc(p.title)+"</a><span class='wx-wp'>&#8377;"+(p.price/100).toLocaleString('en-IN')+"</span></div>";
      }).join('');
    });
  }
  function render(){
    var g=document.getElementById('wx-wishlist-grid');if(!g)return;
    var a=get(),e=document.getElementById('wx-wishlist-empty');
    if(!a.length){g.innerHTML='';if(e)e.hidden=false;return}
    if(e)e.hidden=true;cards(a,g,true);
  }
  function recent(){
    var cur=location.pathname.indexOf('/products/')>-1?handleFrom(location.pathname):null;
    var l=rd(R);
    if(cur){l=l.filter(function(x){return x!==cur});l.unshift(cur);wr(R,l.slice(0,12))}
    var box=document.getElementById('wx-recent');if(!box)return;
    var others=l.filter(function(x){return x!==cur}).slice(0,8);
    if(!others.length){box.hidden=true;return}
    box.hidden=false;cards(others,box.querySelector('.wx-rrow'),false);
  }
  function top(){
    var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Back to top');b.className='wx-top';b.innerHTML="<svg viewBox='0 0 24 24'><path d='M6 15l6-6 6 6'/></svg>";
    document.body.appendChild(b);
    b.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
    window.addEventListener('scroll',function(){b.classList.toggle('is-on',window.scrollY>700)},{passive:true});
  }
  document.addEventListener('click',function(e){var r=e.target.closest&&e.target.closest('[data-rm]');if(r){toggle(r.dataset.rm);render()}});
  var t;function later(){clearTimeout(t);t=setTimeout(inject,150)}
  document.addEventListener('DOMContentLoaded',function(){inject();render();recent();top();new MutationObserver(later).observe(document.body,{childList:true,subtree:true})});
  window.addEventListener('storage',function(){paint();render()});
  paint();
})();
